import LoginComponent from "components/LoginComponent/LoginComponent";
import React, { Dispatch, SetStateAction } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const LoginButtonKD: React.FC<Props> = ({ open, setOpen }) => {
  const { pathname } = useLocation();
  return (
    <LoginComponent
      type={open || pathname === "/" || pathname === "/kd" ? "default" : "primary"}
      text="Logg inn"
      onClick={() => setOpen(false)}
    />
  );
};

export default LoginButtonKD;
